import { gql } from "@apollo/client";

export const GET_INDUSTRIES = gql`
  query GetIndustries {
    industries {
      Id
      name
    }
  }
`;
